<template>
  <div>
    <headingComp :heading="'D. Sancho II'" scroll="false"/>
    <div class="sidebar-container">
      <div class="sidebar">
        <ol>
          <li @click="scrollTo('.hotel')">Hótel D. Sancho II</li>
          <li @click="scrollTo('.restaurante')">Restaurante O Dourado</li>
        </ol>
      </div>
    </div>
    <section class="post-header hotel">
      <h2>O Hotel D. Sancho II varius elit, ac pharetra orci vulputate ac Vivamus</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Praesent tempor, nulla non pellentesque tristique, sem metus luctus magna, id porttitor elit nisl ut est. </p>
      <p>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Praesent tempor, nulla non pellentesque tristique, sem metus luctus magna, id porttitor elit nisl ut est. </p>
    </section>
    <section class="image-container-1">
      <img src="../assets/estalagem/estalagem06.jpg" class="image-1"/>
      <img src="../assets/estalagem/estalagem16.jpg" class="image-2"/>
    </section>
    <section class="text-container-1">
      <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Duis condimentum nulla.</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
    </section>
    <section class="slider-container">
      <div class="slider">
        <!-- <article class="slide"></article> -->
        <img src="../assets/estalagem/estalagem19.jpg" class="slide" />
      </div>
    </section>
    <section class="large-image-1 restaurante"></section>
    <section class="image-container-2">
      <img src="../assets/estalagem/estalagem20.jpg" class="image-1"/>
      <img src="../assets/estalagem/estalagem03.jpg" class="image-2"/>

    </section>
    <section class="text-container-2">
      <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
    </section>
    <!-- <section class="large-image-2"></section> -->
    <img src="../assets/estalagem/estalagem20.jpg" class="large-image-2"/>


    <section class="large-image-1 bar"></section>
    <section class="image-container-2">
      <!-- <div class="image-1"></div> -->
      <!-- <div class="image-2"></div> -->
      <img src="../assets/estalagem/estalagem20.jpg" class="image-1"/>
      <img src="../assets/estalagem/estalagem03.jpg" class="image-2"/>
    </section>
    <section class="text-container-2">
      <h2>Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras sagittis varius velit quis condimentum. Duis condimentum nulla a massa elementum ultricies eu et ex.</p>
    </section>
    <!-- <section class="large-image-3"></section> -->
    <img src="../assets/estalagem/estalagem20.jpg" class="large-image-2"/>

    <section class="image-container-3">
      <!-- <div class="image-1"></div> -->
      <img src="../assets/estalagem/estalagem02.jpg" class="image-1"/>

    </section>
  </div>
</template>
<script>

export default {
  name: 'estalagem',
  props: [],
  components: {
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
    scrollTo (key) {
      this.$el.querySelector(key).scrollIntoView({behavior: 'smooth'})
    }
  }
}
</script>
<style lang="scss" scoped>
h2 {
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
}
p {
  margin-top: 20px;
  line-height: 24px;
}
.sidebar-container {
  position: relative;
}
.sidebar {
  width: 20%;
  position: absolute;
  top: 144px;
  ol {
    margin-left: 20px;
    li {
      font-size: 24px;
      font-weight: bold;
      padding: 5px 0;
      color: #f6b92f;
      opacity: 0.5;
      cursor: pointer;
    }
    li.active, li:hover {
      opacity: 1;
    }
  }

  @media (max-width: 700px){
    width: calc(100% - 32px);
    margin: 0 16px;
    top: 33px;

    ol {
      flex-direction: row;
      display: flex;
      width: 100%;
      margin: 0 auto;
      align-items: center;
      justify-content: center;

      li + li {
        margin-left: 16px;
      }
    }
  }
}
.post-header {
  margin: 0 5% 0 20%;
  width: calc(75% - 60px);
  background: #eee3d4;
  margin-top: -100px;
  padding: 50px 30px 100px 30px;
  color: #a79374;
  z-index: 10;
  position: relative;
  p {
    color: #000000;
  }

  @media (max-width: 700px){
    width: calc(100% - 32px - 60px);
    margin: 0 16px;
    margin-top: 100px;
    padding: 50px 30px 100px 30px;
  }
}
.image-container-1 {
  display: flex;
  position: relative;
  & > * {
    width: 30%;
    height: 300px;
    /* background: #f6ede0; */
    position: relative;
    z-index: 20;
  }
  .image-1 {
    margin: 50px 5% 100px 22.5%;
    object-fit: contain;
  }
  .image-2 {
    position: absolute;
    right: calc(15% - 50px);
    top: -50px;
    object-fit: contain;

  }

  @media (max-width: 700px){
    .image-1, .image-2 {
      margin: 16px auto;
      width: calc(45%);
      top: 0;
      position: relative;
      right: 0;
    }
  }

  @media (max-width: 500px){
      display: flex;
      flex-direction: column;
    .image-1, .image-2 {
      width: calc(100% - 32px);
    }

    .image-2 {
      margin-top: 0;
    }
  }
}
.text-container-1 {
  margin-left: 35%;
  margin-right: 20%;

  @media (max-width: 700px){
    margin: 0 16px;
  }
}
.slider-container {
  margin: 50px 15% 100px 20%;
  .slider {
    width: 100%;
    /* background: #eee3d4; */
    position: relative;
    z-index: 20;

    .slide {
      width: 70vw;
      max-width: 900px;
      object-fit: contain;
    }
  }

  @media (max-width: 700px){
    margin: 16px;
    .slider {
      margin: 0 auto;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      .slide {
        margin: 0 auto;
        width: calc(100vw - 32px);
        max-width: 600px;
        object-fit: contain;
      }
    }
  }
}
.large-image-1 {
  width: 100%;
  height: 650px;
  background: #f6ede0;
  position: relative;
  z-index: 20;

  @media (max-width: 700px){
    margin: 0 16px;
    width: calc(100% - 32px);
  }
}
.image-container-2 {
  display: flex;
  position: relative;
  & > * {
    width: 30%;
    height: 300px;
    /* background: #eee3d4; */
    position: relative;
    z-index: 20;
  }
  .image-1 {
    margin-left: 5%;
    margin-top: -100px;
    object-fit: contain;

  }
  .image-2 {
    margin-left: -50px;
    object-fit: contain;
    margin-top: -50px;
  }

    @media (max-width: 700px){
    .image-1, .image-2 {
      margin: 16px auto;
      width: calc(45%);
      top: 0;
      position: relative;
      right: 0;
    }
  }

    @media (max-width: 500px){
      display: flex;
      flex-direction: column;
    .image-1, .image-2 {
      width: calc(100% - 32px);
    }

    .image-2 {
      margin-top: 0;
    }
  }
}
.text-container-2 {
  margin-left: 5%;
  margin-right: 55%;
  margin-top: 100px;
  position: relative;
  h2 p{
    position: absolute;
  }

  @media (max-width: 700px){
    margin: 0 16px;
  }
}
.large-image-2 {
  width: 70%;
  /* height: 600px; */
  /* background: #f6ede0; */
  margin-left: 25%;
  margin-right: 5%;
  margin-top: -150px;
  margin-bottom: 180px;
  object-fit: contain;

  @media (max-width: 700px){
    margin: 16px 16px;
    width: calc(100% - 32px);
  }
}
.image-container-3 {
  display: flex;
  position: relative;
  margin-bottom: 200px;
  & > * {
    width: 25%;
    height: 300px;
    /* background: #eee3d4; */
  }

  .image-1 {
    margin-left: 70%;
    margin-top: -250px;
    object-fit: contain;
  }
  @media (max-width: 700px){
    margin-bottom: 100px;
    .image-1 {
      margin: 16px 16px;
      width: 100%;
      top: 0;
      position: relative;
      right: 0;
    }
  }
}
.text-container-3 {
  background: rgb(207, 207, 207);
  padding: 50px 30px;
  margin-right: 5%;
  margin-left: 20%;
  margin-top: -25px;

  h2 p{
    position: absolute;
  }

  @media (max-width: 700px){
    margin: 0 16px;
  }
}
.large-image-3 {
  width: 70%;
  height: 600px;
  background: #f6ede0;
  margin-left: 15%;
  margin-right: 15%;
  margin-top: -150px;

  @media (max-width: 700px){
    margin: 16px 16px 0;
    width: calc(100% - 32px);
  }
}
</style>